import React, { useState, useRef, useEffect } from 'react';

const AccordionItem = ({ title, content, readmore, readmorecount }) => {
    const [isActive, setIsActive] = useState(false);
    const contentRef = useRef(null);
    const [showFullDescription, setFullDescription] = useState(false);

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.style.maxHeight = isActive ? `${contentRef.current.scrollHeight + 40}px` : '0';
        }
    }, [isActive, showFullDescription]);

    const showFullDescriptionHandler = () => {
        setFullDescription(!showFullDescription);
    };

    return (
        <div className={`accordion-item ${isActive ? 'active' : ''}`}>
            <div className="accordion-header" onClick={() => setIsActive(!isActive)}>
                <p>{title}</p>
                <span>{isActive ? "-" : "+"}</span>
            </div>
            <div className="accordion-content" ref={contentRef}>
                <div className="content-inner">
                    {readmore && showFullDescription &&
                        <div>
                            <div className="content-text" dangerouslySetInnerHTML={{ __html: content }}></div>
                            <span className="expand expanded" onClick={showFullDescriptionHandler}>
                                See Less
                            </span>
                        </div>
                    }
                    {readmore && !showFullDescription &&
                        <div>
                            {content.slice(0, readmorecount)}...&nbsp;
                            <span className="expand" onClick={showFullDescriptionHandler}>
                                See More
                            </span>
                        </div>
                    }
                    {!readmore &&
                        <div className="content-text" dangerouslySetInnerHTML={{ __html: content }}></div>
                    }
                </div>

            </div>
            <div className="accordion-footer"></div>
        </div>
    );
};

export default AccordionItem;